module.exports = __webpack_public_path__ + "static/media/dollorimg.ee9eb5cb.svg";